// src/models/profession/tinTuc/tinTucValidator.js
// → CHỈ CHỨA RULES, KHÔNG CÓ extend() NỮA!

export const commonRules = {
  name: 'required|min:3|max:200',
  code: 'required|min:3|max:200',
}

export const commonValidator = {
  rules: commonRules,
}